/**
 * Password validation rules:
 * 1. Minimum 8 characters
 * 2. Cannot be the same as account
 * 3. At least 3 of the following 4:
 *    - Uppercase (A-Z)
 *    - Lowercase (a-z)
 *    - Digit (0-9)
 *    - Special character (!@#$%^&* etc.)
 */

export const validatePassword = (password, account = "") => {
  const hasMinLength = password.length >= 8
  const notSameAsAccount = !account || password !== account
  const hasUppercase = /[A-Z]/.test(password)
  const hasLowercase = /[a-z]/.test(password)
  const hasDigit = /[0-9]/.test(password)
  const hasSpecial = /[^A-Za-z0-9]/.test(password)

  const complexityCount = [hasUppercase, hasLowercase, hasDigit, hasSpecial].filter(Boolean).length
  const meetsComplexity = complexityCount >= 3

  return {
    hasMinLength,
    notSameAsAccount,
    hasUppercase,
    hasLowercase,
    hasDigit,
    hasSpecial,
    complexityCount,
    meetsComplexity,
  }
}

export const isPasswordValid = (password, account = "") => {
  const result = validatePassword(password, account)
  return result.hasMinLength && result.notSameAsAccount && result.meetsComplexity
}
